import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CurrencyInput from 'react-currency-input-field';
import { autoCompleteSx } from '../../helpers/utils'
import { HIGHLIGHT_TYPE } from "../../configs/constants";
import  IframeCard  from "../../components/IframeCard";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col
} from "reactstrap";

function mountEvent(name,value) {
  return {
    target:{
      name: name,
      value: value,
    }
  };
};

const HangtagComponent = ({
  onChangeOriginalValue,
  onChangeClubValue,
  onChange,
  onClick,
  onCancel,
  hangtag,  
  products,
  product,
  onInputChangeProduct,
  productIsLoading,
  page,
  preview,
  onChangeIsFractioned,
  // onChangeValue,
  // onChangeName,
  // onChangeCode,
  onChangeDescription
}) => {
  return (
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h5 className="title">Etiqueta</h5>
              </CardHeader>
              <CardBody>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    onClick();
                  }}
                >
                  <IframeCard onRefresh={preview} />
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Dispositivo</span>
                        <Input
                          id="deviceId"
                          name="deviceId"
                          value={hangtag?.deviceId}
                          placeholder="Dispositivo"
                          type="text"
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Página</span>
                        <Input
                          id="pageDescription"
                          name="pageDescription"
                          value={page?.description}
                          placeholder="Página"
                          type="text"
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>               
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span style={{width: "100%"}}>Buscar produto</span>
                        <Autocomplete
                          freeSolo
                          noOptionsText={"Nenhum"}
                          onInputChange={(event, value) =>                         
                            onInputChangeProduct(event, value)
                          }
                          loadingText={"Carregando"}
                          loading={productIsLoading}
                          style={{paddingBottom: "10px"}}   
                          id="product"
                          value={product}               
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          options={products.map((product) => product)}
                          size="small"
                          renderInput={(params) => (
                            <TextField  {...params}  variant='standard'/>
                          )}
                          sx={autoCompleteSx()}
                          renderOption={(props, option) => {
                            return (
                              <span  {...props}>
                                <Row>
                                  <Col xs={12} md={12} style={{textAlign: "left"}}>
                                    {option.name}
                                  </Col>                              
                                </Row>
                              </span>
                            );
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Código do produto</span>
                        <Input
                          name="productCode"
                          type="number"
                          placeholder="Produto"
                          value={hangtag?.product?.code}
                          disabled={true}
                          // onChange={(e) => onChangeCode(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Produto</span>
                        <Input
                          name="productName"
                          type="text"
                          placeholder="Produto"
                          value={hangtag?.product?.name}
                          disabled={true}
                          // onChange={(e) => onChangeName(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Preço</span>
                        <CurrencyInput
                          id="valueStr"
                          className="form-control"
                          value={hangtag?.product?.valueStr || ""}
                          name="valueStr"
                          decimalsLimit="2"             
                          placeholder="0,00"
                          disabled={true}
                          // onValueChange={(value) => onChangeValue(value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                        <FormGroup>
                          <span>Nome do produto que vai aparecer na etiqueta, se vazio apresenta o nome acima</span>
                          <Input
                            id="description"
                            name="description"
                            type="text"
                            placeholder="Ex: Morango"
                            value={hangtag?.product?.description}
                            onChange={(e) => onChangeDescription(e.target.value)}
                          />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <label>Fraciona 100Gr?</label>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            color={hangtag?.product?.isFractioned ? "primary" : "secondary"}
                            onClick={() => onChangeIsFractioned(true)}
                            className="btn-sm"
                          >
                            Sim
                          </Button>
                          <Button
                            color={!hangtag?.product?.isFractioned ? "primary" : "secondary"}
                            onClick={() => onChangeIsFractioned(false)}
                            className="btn-sm"
                            style={{ marginLeft: "10px" }}
                          >
                            Não
                          </Button>
                          {hangtag?.product?.isFractioned && (
                            <Input
                              id="fractionedValue"
                              type="text"
                              className="form-control"
                              value={((Math.floor((hangtag?.product?.value || 0) / 1000 * 100) / 100).toFixed(2)).replace('.', ',')}
                              disabled
                              style={{ marginLeft: "15px", width: "100%" }}
                              placeholder="0,00"
                            />
                          )}
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>            
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup>
                        <span>Tipo de Destaque</span>
                        <ButtonGroup style={{ width: "100%", flexDirection: "column" }}>
                        <Button
                            color="info"
                            className={classNames("btn-simple", { active: hangtag?.highlightType === HIGHLIGHT_TYPE.none })}
                            outline
                            style={{width: "50%"}}
                            onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.none))}
                          >
                            Nenhum
                          </Button>  
                          <Button
                            color="info"
                            className={classNames("btn-simple", { active: hangtag?.highlightType === HIGHLIGHT_TYPE.blink })}
                            outline
                            style={{width: "50%"}}
                            onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.blink))}
                          >
                            Pisca
                          </Button>                       
                          <Button
                            color="info"
                            className={classNames("btn-simple", { active: hangtag?.highlightType === HIGHLIGHT_TYPE.offer })}
                            outline
                            style={{width: "50%"}}
                            onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.offer))}
                          >
                            Oferta
                          </Button>
                          <Button
                            color="info"
                            className={classNames("btn-simple", { active: hangtag?.highlightType === HIGHLIGHT_TYPE.club })}
                            outline
                            style={{width: "50%"}}
                            onClick={() => onChange(mountEvent("highlightType", HIGHLIGHT_TYPE.club))}
                          >
                            Clube
                          </Button>
                        </ButtonGroup>
                      </FormGroup>
                    </Col>           
                    <Col xs={12} md={6}>                   
                      <FormGroup style={{display: hangtag?.highlightType === HIGHLIGHT_TYPE.offer ? "block" : "none"}}>
                        <span>Preço original, sem oferta</span>
                        <CurrencyInput
                            id="originalValueStr"
                            className="form-control"
                            value={hangtag?.product?.originalValueStr || ""}
                            name="originalValueStr"
                            decimalsLimit="2"             
                            placeholder="0,00"
                            onValueChange={(value) => onChangeOriginalValue(value)}
                        />
                      </FormGroup>
                      <FormGroup style={{display: hangtag?.highlightType === HIGHLIGHT_TYPE.club ? "block" : "none"}}>
                        <span>Preço no clube de descontos</span>
                        <CurrencyInput
                            id="clubValueStr"
                            className="form-control"
                            value={hangtag?.product?.clubValueStr || ""}
                            name="clubValueStr"
                            decimalsLimit="2"             
                            placeholder="0,00"
                            onValueChange={(value) => onChangeClubValue(value)}
                        />
                      </FormGroup>
          
                    </Col>
                  </Row>   
                  <Row>
                    <Col style={{textAlign: "right"}}>                
                      <Button
                        className="btn-fill btn-xs"
                        color="danger"
                        type="button"
                        onClick={()=>onCancel()}
                      >
                        Voltar
                      </Button>
                      <Button
                        className="btn-fill btn-xs"
                        color="primary"
                        type="submit"
                      >
                        Salvar
                      </Button>
                    </Col>
                  </Row>                  
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
  );
};

HangtagComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  hangtag: PropTypes.object.isRequired
};

export default HangtagComponent;